import { render, staticRenderFns } from "./jobcardDetail.vue?vue&type=template&id=39d9a3fa"
import script from "./jobcardDetail.ts?vue&type=script&lang=js&external"
export * from "./jobcardDetail.ts?vue&type=script&lang=js&external"
import style0 from "./jobcardDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports